export enum BannerEvents {
  Load = 'componentLoaded',
  SwitchNow = 'switchNow',
  OpenTariff = 'openTariff',
  LearnMore = 'learnMore',
  ExclusiveAction = 'exclusiveAction',
}

export enum BannerDynamicFields {
  MonthlyCost = 'monthlycost',
  AnnualCost = 'annualcost',
  TariffName = 'tariff',
  ExclusiveContent = 'exclusive-content',
  ExclusiveAction = 'exclusive-action'
}

export enum BannerPlacement {
  TenancyBanner = 'QUOTES_PAGE_TOP_ZONE',
  QuotesTag = 'TARIFF_CARD_OUTER_TOP_LEFT',
  EvTariff2 = 'TARIFF_CARD_OUTER_TOP_LEFT_2',
  PeakSaveSunday = 'TARIFF_CARD_INNER_TOP_RIGHT',
  ContractInfo = 'TARIFF_CARD_INNER_BELOW_CONTRACT',
  InfoBar = 'TARIFF_CARD_BELOW_TARIFF',
  EvTariff = 'TARIFF_CARD_INNER_TOP_LEFT',
  CTMRewards = 'TARIFF_CARD_CTM_REWARDS',
  SupplierRewards = 'TARIFF_CARD_SUPPLIER_REWARDS',
}
